import './index.css'
import {useRef, useState} from "react";
import {ReactComponent as RiUploadLine} from "@/assets/icons/ri-upload-line.svg";

const activeEvent = [
  'dragenter',
  'dragover'
]

const inactiveEvent = [
  'dragleave'
]

const FileInput: React.FC<FileInputProps> =
  ({
     setFile,
     accept,
     classNames
   }) => {
    const inputRef = useRef(null)
    const [active, setActive] = useState(false)
    const handleChange = (e) => {
      if (e.target.files && e.target.files[0]) {
        setFile(e.target.files[0])
      }
    }
    const handleClick = () => {
      inputRef.current.click()
    }
    const handleDrag = (e) => {
      const event = e as Event
      event.preventDefault()
      event.stopPropagation()
      if (activeEvent.includes(event.type)) {
        setActive(true)
      } else if (inactiveEvent.includes(event.type)) {
        setActive(false)
      }
    }
    const handleDrop = (e) => {
      const event = e as InputEvent
      event.preventDefault();
      event.stopPropagation();
      setActive(false);
      if (event.dataTransfer.files && event.dataTransfer.files[0]) {
        setFile(event.dataTransfer.files[0])
      }
    };
    const getAcceptType = () => accept && accept.join(', ')
    
    return (
      <div
        aria-hidden="true"
        className={`flex-grow upload ${active ? 'upload-active' : 'nani'} ${classNames}`}
        onClick={handleClick}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}>
        <input
          onChange={handleChange}
          ref={inputRef}
          type="file"
          multiple={false}
          className="hidden"
          accept={getAcceptType()}/>
        <div className="text-red-primary">
          <RiUploadLine/>
        </div>
        <div className="flex flex-col gap-1 justify-center items-center">
          <div className="text-jsm">Upload file or drag and drop</div>
          <div className="text-jxs text-grey-dark">JPG, PNG up to 2 MB</div>
        </div>
      </div>
    )
  }

export default FileInput;